import baseAPI from "@/api/base";
import {
    GetSubscriptionPlans,
    GetSubscriptions,
    InitializeSubscription,
} from "@/dtos/subscription.dto";
import {
    SUBSCRIPTION_INITIALIZE_URL,
    SUBSCRIPTION_PLAN_URL,
    SUBSCRIPTION_URL,
    SUBSCRIPTION_VERIFY_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class Subscription {
    // GET /subscription — the signed-in user's organization subscriptions
    // (current + history), newest first, with plan + payment relations.
    static getSubscriptions = async (
        params: GetSubscriptions,
    ): Promise<AxiosResponse> => {
        return baseAPI.get(SUBSCRIPTION_URL, { params: params ?? {} });
    };

    // GET /subscription-plan — the plan catalogue used for upgrades.
    static getSubscriptionPlans = async (
        params: GetSubscriptionPlans,
    ): Promise<AxiosResponse> => {
        return baseAPI.get(SUBSCRIPTION_PLAN_URL, { params: params ?? {} });
    };

    // POST /subscription/initialize — returns a Chapa checkout URL to redirect to.
    static initialize = async (
        body: InitializeSubscription,
    ): Promise<AxiosResponse> => {
        return baseAPI.post(SUBSCRIPTION_INITIALIZE_URL, body);
    };

    // Confirm a payment after the Chapa return. The confirmation page may identify
    // the payment by its Chapa tx_ref (GET /subscription/verify/:txRef) or — when
    // opened with the ids handed back by /initialize — by paymentId / subscriptionId
    // (GET /subscription/verify?paymentId=…). Public endpoint; no auth required.
    static verifyPayment = async (
        identifier:
            | string
            | { txRef?: string; paymentId?: string; subscriptionId?: string },
    ): Promise<AxiosResponse> => {
        const { txRef, paymentId, subscriptionId } =
            typeof identifier === "string" ? { txRef: identifier } as any : identifier ?? {};

        if (txRef) {
            return baseAPI.get(`${SUBSCRIPTION_VERIFY_URL}/${encodeURIComponent(txRef)}`);
        }
        return baseAPI.get(SUBSCRIPTION_VERIFY_URL, {
            params: {
                ...(paymentId ? { paymentId } : {}),
                ...(subscriptionId ? { subscriptionId } : {}),
            },
        });
    };
}

export default Subscription;
